import { api } from "../config/api";

/**
 * Download a file (e.g. Firebase Storage URL) via the tracking download-attachment endpoint.
 * Triggers a direct download instead of opening the URL in the browser.
 * @param {string} url - Full URL of the file (e.g. firebasestorage.googleapis.com)
 * @param {string} [filename] - Suggested filename for the download
 * @returns {Promise<void>}
 */
export async function downloadAttachment(url, filename = "document") {
  if (!url) {
    throw new Error("Attachment URL is required");
  }

  const response = await api.get("/tracking/download-attachment", {
    params: { url, filename },
    responseType: "blob",
  });

  const blob = response.data;
  const blobUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = filename || "document";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(blobUrl);
}
